import { FC, SVGProps } from 'react';

export const SearchWithBgIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="15.5" cy="15.5" r="15" fill="#C8E1F7" />
    <path
      d="M14.5033 19.5053C17.2665 19.5053 19.5065 17.2656 19.5065 14.5027C19.5065 11.7398 17.2665 9.5 14.5033 9.5C11.74 9.5 9.5 11.7398 9.5 14.5027C9.5 17.2656 11.74 19.5053 14.5033 19.5053Z"
      stroke="#204366"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21.5007 21.5003L18.0391 18.0391" stroke="#204366" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
